import { render, staticRenderFns } from "./LoginFormTwoFa.vue?vue&type=template&id=0bb8dd96&scoped=true"
import script from "./LoginFormTwoFa.vue?vue&type=script&lang=js"
export * from "./LoginFormTwoFa.vue?vue&type=script&lang=js"
import style0 from "./LoginFormTwoFa.vue?vue&type=style&index=0&id=0bb8dd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8dd96",
  null
  
)

export default component.exports